import { IModalConfirm } from "../interfaces";

export class ModalConfirmModel implements IModalConfirm {
  open = false;
  title = "";
  message = "";
  onConfirm = () => {};
}
